"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _defineProperty2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _zhjySerach = _interopRequireDefault(require("@/components/search/zhjySerach.vue"));
var _zhjyPagination = _interopRequireDefault(require("@/components/zhjyPagination/zhjyPagination.vue"));
var _zhjyTable = _interopRequireDefault(require("@/components/table/zhjyTable.vue"));
var _funBtn = _interopRequireDefault(require("@/components/funBtn/funBtn.vue"));
var _works = require("@/api/works/works");
var _projectType = require("@/api/project/projectType");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      minWidth: 200,
      multipleSelection: [],
      tableData: [],
      defaultColumn: [{
        name: "项目名称",
        prop: "matchName",
        isShow: true,
        width: "100"
      }, {
        name: "项目类型",
        prop: "matchTypeName",
        isShow: true,
        width: "100"
      }, {
        name: "作品数量",
        prop: "worksCount",
        isShow: true,
        width: "100"
      }],
      formatters: {},
      modelData: {
        name: "",
        matchType: ""
      },
      queryGroup: [{
        label: "项目名称",
        type: "input",
        model: "name",
        placeholder: "项目名称"
      }, {
        label: "项目类型",
        type: "select",
        model: "matchType",
        options: [],
        placeholder: "项目类型"
      }],
      checkBoxData: [],
      page: {
        pageNum: 1,
        pageSize: 10
      },
      total: null
    };
  },
  components: {
    ZhjyTable: _zhjyTable.default,
    FunBtn: _funBtn.default,
    ZhjyPagination: _zhjyPagination.default,
    ZhjySerach: _zhjySerach.default
  },
  created: function created() {
    this.projectTypeListAll();
  },
  mounted: function mounted() {
    this.list();
  },
  methods: {
    list: function list() {
      var _this = this;
      (0, _works.getMatchesForWorks)(_objectSpread(_objectSpread({}, this.modelData), this.page)).then(function (res) {
        _this.tableData = res.data.list;
        _this.total = res.data.total;
      });
    },
    projectTypeListAll: function projectTypeListAll() {
      var _this2 = this;
      (0, _projectType.projectTypeListAll)({}).then(function (res) {
        res.data.list.forEach(function (item) {
          _this2.queryGroup[1].options.push({
            value: item.id,
            name: item.matchTypeName
          });
        });
      });
    },
    handleSelectionChange: function handleSelectionChange(row) {
      var _this3 = this;
      this.checkBoxs = [];
      row.forEach(function (item) {
        _this3.checkBoxs.push(item.id);
      });
    },
    handleCurrentChange: function handleCurrentChange(e) {
      this.page.pageNum = e;
      this.list();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.page.pageSize = e;
      this.page.pageNum = 1;
      this.list();
    },
    search: function search() {},
    detail: function detail(row) {
      this.$router.push({
        path: "/entryDesignTest/list",
        query: {
          matchId: row.id
        }
      });
    }
  }
};